var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTv = function SvgTv(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21724_19623",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#4171CF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21724_19623)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#6A97AE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.5,
    y: -2.5,
    width: 16.6667,
    height: 12.5,
    fill: "#0A2378"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8346 -2.08333L9.16797 2.5L-1.66536 10H-5.83203L12.5013 -2.5L15.8346 -2.08333Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.83203 -1.24935L-0.832031 2.91732L10.8346 10.0007H14.168V9.16732L-2.91536 -1.66602L-5.83203 -1.24935Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33203 6.66602L13.7487 9.99935H14.1654V9.58268L9.58203 6.66602H8.33203Z",
    fill: "#BD2E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.16797 0L1.2487 3.33333H1.66536V2.91667L-2.91797 0H-4.16797Z",
    fill: "#BD2E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.41797 2.91732L12.0846 -1.66602L12.5013 -1.24935L5.83464 3.33398L5.41797 2.91732Z",
    fill: "#BD2E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.33203 10L3.33464 5.41667H4.16797L-2.4987 10H-3.33203Z",
    fill: "#BD2E33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.91797,
    y: -1.66602,
    width: 2.5,
    height: 11.6667,
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.168,
    y: 2.91602,
    width: 3.33333,
    height: 16.6667,
    transform: "rotate(90 14.168 2.91602)",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.168,
    y: 3.54102,
    width: 2.08333,
    height: 16.6667,
    transform: "rotate(90 14.168 3.54102)",
    fill: "#BD2E33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.33203,
    y: -1.66602,
    width: 1.66667,
    height: 11.6667,
    fill: "#BD2E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6693 9.16602L16.8564 9.74183H17.4618L16.972 10.0977L17.1591 10.6735L16.6693 10.3177L16.1794 10.6735L16.3665 10.0977L15.8767 9.74183H16.4822L16.6693 9.16602Z",
    fill: "#FED43E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6693 13.332L16.8564 13.9079H17.4618L16.972 14.2637L17.1591 14.8395L16.6693 14.4837L16.1794 14.8395L16.3665 14.2637L15.8767 13.9079H16.4822L16.6693 13.332Z",
    fill: "#FED43E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5833 14.582L14.7704 15.1579H15.3759L14.8861 15.5137L15.0732 16.0895L14.5833 15.7337L14.0935 16.0895L14.2806 15.5137L13.7908 15.1579H14.3962L14.5833 14.582Z",
    fill: "#FED43E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5013 17.5L7.6884 18.0758H8.29385L7.80403 18.4317L7.99112 19.0075L7.5013 18.6516L7.01148 19.0075L7.19858 18.4317L6.70875 18.0758H7.31421L7.5013 17.5Z",
    fill: "#FED43E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7985 11.9146L15.193 11.9215L15.0126 12.4994L14.8189 11.9258L14.2135 11.9327L14.6992 11.5713L14.5055 10.9976L14.9994 11.3479L15.4851 10.9864L15.3046 11.5643L15.7985 11.9146Z",
    fill: "#FED43E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5055 12.9576L12.9001 12.9645L12.7196 13.5424L12.5259 12.9688L11.9205 12.9757L12.4062 12.6142L12.2125 12.0406L12.7064 12.3908L13.1921 12.0294L13.0116 12.6073L13.5055 12.9576Z",
    fill: "#FED43E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0055 15.4576L10.4001 15.4645L10.2196 16.0424L10.0259 15.4688L9.42049 15.4757L9.90621 15.1142L9.71253 14.5406L10.2064 14.8908L10.6921 14.5294L10.5116 15.1073L11.0055 15.4576Z",
    fill: "#FED43E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0055 17.9576L10.4001 17.9645L10.2196 18.5424L10.0259 17.9688L9.42049 17.9757L9.90621 17.6142L9.71253 17.0406L10.2064 17.3908L10.6921 17.0294L10.5116 17.6073L11.0055 17.9576Z",
    fill: "#FED43E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5055 17.1236L12.9001 17.1305L12.7196 17.7084L12.5259 17.1348L11.9205 17.1417L12.4062 16.7803L12.2125 16.2066L12.7064 16.5569L13.1921 16.1954L13.0116 16.7733L13.5055 17.1236Z",
    fill: "#FED43E"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTv);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tv.7eaab40e3acdaaf683b19dedd72a98df.svg";